import { ScenarioSizing } from '@/dto/scenario/sizing/ScenarioSizing';
import { DtoExt } from '@/classes/scenario/DtoExt';
import { SizingAlgorithmRef, SizingTypeRef } from '@/dto/scenario/sizing/SizingReference';

export class ScenarioSizingExt extends DtoExt {

  public static fromDto(dto: ScenarioSizing): ScenarioSizingExt {
    return new ScenarioSizingExt({
      typeRef: dto.typeRef,
      algorithmRef: dto.algorithmRef || SizingAlgorithmRef.algo_v3,
      hasBatteryRange: dto.hasBatteryRange,
      pvCapacity: dto.pvCapacity,
      pvMin: dto.pvMin,
      pvMax: dto.pvMax,
      pvReport: dto.pvReport,
      batteryCapacity: dto.batteryCapacity,
      batteryMin: dto.batteryMin,
      batteryMax: dto.batteryMax,
      batteryReport: dto.batteryReport,
      uuid: dto.uuid
    });
  }

  public typeRef: SizingTypeRef | null = SizingTypeRef.pv_and_battery;
  public algorithmRef: SizingAlgorithmRef | null = null;
  public hasBatteryRange: boolean | null = null;

  public pvCapacity: number | null = null; // kept for legacy reason; to be deleted soon!
  public pvMin: number | null = null;
  public pvMax: number | null = null;
  public pvReport: number | null = null;

  public batteryCapacity: number | null = null;
  public batteryMin: number | null = null;
  public batteryMax: number | null = null;
  public batteryReport: number | null = null;

  public uuid: string | null = null;

  constructor(options?: Partial<ScenarioSizingExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
      this.typeRef = this.typeRef ? SizingTypeRef[this.typeRef] : null;
    }
  }

  public toDto(): ScenarioSizing {
    return new ScenarioSizing({
      typeRef: this.typeRef,
      algorithmRef: this.algorithmRef,
      hasBatteryRange: this.hasBatteryRange,
      pvCapacity: this.pvCapacity,
      pvMin: this.pvMin,
      pvMax: this.pvMax,
      pvReport: this.pvReport,
      batteryCapacity: this.batteryCapacity,
      batteryMin: this.batteryMin,
      batteryMax: this.batteryMax,
      batteryReport: this.batteryReport,
      uuid: this.uuid
    });
  }
}
